import axios from "shared/api/axiosConfig";
import { encryptApiBodyFromString, encryptApiBodyFromJSON, decryptApiBodyToJson } from "shared/api/cryptApiBody";
import apiInstance from "shared/api/axiosConfig";


const baseURL = apiInstance.getUri();

// Contrat de retour : { error: false, message, quickReplies } = réponse de Kuma ;
// { error: true, message } = échec (jamais d'objet Error brut)
export async function chatCompletionsPremium(userMessage, thread_id, user_id, tool_name) {
  try{
    const res = await fetch(`${baseURL}/client/chat/messages/premium`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        encrypt: encryptApiBodyFromJSON({userMessage: userMessage, threadId: thread_id, user_id: user_id, tool_name: tool_name}),
      }),
    });

    if (!res.ok) {
      const message = res.status === 401 || res.status === 403
        ? "Session expirée, veuillez vous reconnecter."
        : "Le service Kuma est momentanément indisponible. Veuillez réessayer.";
      return { error: true, message };
    }

    const body = await res.json();
    const data = body['assistantMessage'];
    if (typeof data !== "string") {
      return { error: true, message: "Le service Kuma est momentanément indisponible. Veuillez réessayer." };
    }
    return {
      error: false,
      message: data,
      quickReplies: Array.isArray(body['quickReplies']) ? body['quickReplies'] : [],
    };
  } catch(e){
    console.log(`chatCompletionsPremium error: ${e}`);
    return { error: true, message: "Impossible de contacter le serveur. Vérifiez votre connexion." };
  }
}

export async function get_thread_id(){
  try {
    const response = await axios.get("/client/chat/thread_id");
    const encrypted_thread = decryptApiBodyToJson(response.data);
    return encrypted_thread.threadId ?? null;
  } catch (error) {
    console.log(`get_thread_id error: ${JSON.stringify(error?.message ?? error)}`);
    return null;
  }
}

// Historique de conversation depuis le serveur (source de vérité) ; null en échec → le composant retombe sur le cache localStorage
export async function get_chat_history(user_id){
  try {
    const res = await fetch(`${baseURL}/client/chat/history`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        encrypt: encryptApiBodyFromJSON({user_id: user_id}),
      }),
    });

    if (!res.ok) return null;

    const data = decryptApiBodyToJson(await res.json());
    return Array.isArray(data?.messages) ? data.messages : null;
  } catch (error) {
    console.log(`get_chat_history error: ${error}`);
    return null;
  }
}



export async function file_upload(file, ai_thread, tool_name, user_id) {
  const formData = new FormData();
  /* console.log("Fichier sélectionné :", file);
  console.log("Type :", file instanceof File); */
  formData.append("file", file);          // multer will capture this
  formData.append("ai_thread", ai_thread); // will be in req.body
  formData.append("tool_name", tool_name);
  formData.append("user_id", user_id);

  try {
    const response = await axios.post("/client/chat/messages/temp_files", formData,  {
			headers: {
				'Content-Type': 'multipart/form-data',
			}
		});

    if (response.status === 200) {
      console.log(`respnse data : ${JSON.stringify(response.data)}`)
      return response.data;
    }

    if (response.status === 400) {
      throw new Error("Requête invalide : informations manquantes ou invalides.");
    }
  } catch (error) {
    if (error?.response) {
      if (error.response.status === 400) {
        console.log(error);
        throw new Error(error.response.data.message || "Données invalides.");
      } else if (error.response.status === 500) {
        console.log(error);
        throw new Error("Une erreur interne est survenue lors de l'envoi du fichier.");
      }
    }
    console.log(error);
    throw new Error("Impossible de contacter le serveur.");
  }
}

export async function delete_files(user_id){

  console.log(`Deleting files`);
  const res = await fetch(`${baseURL}/client/chat/clear_files`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      encrypt: encryptApiBodyFromJSON({user_id: user_id}),
    }),
  });

  // parse JSON response
  const data = await res.json();

  console.log(`res: ${JSON.stringify(decryptApiBodyToJson((data)))}`);
  return res;


}